module.exports = __webpack_public_path__ + "static/img/智能锂电池.35cdbec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/智能锂电池.jpg
// module id = JFWf
// module chunks = 1